import { computed, Injectable, inject } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { DataMartTable } from '@r1-compass-library/models';
import { DataMartService } from '@r1-compass-library/services';
import { Observable, exhaustMap } from 'rxjs';

export interface DataMartTableState {
    table: DataMartTable | undefined;
}

const initialState: DataMartTableState = {
    table: undefined,
};

@Injectable()
export class DataMartTablesStore extends ComponentStore<DataMartTableState> {
    readonly #dataMartService = inject(DataMartService);

    table$ = this.select(state => state.table);
    table = this.selectSignal(state => state.table);
    fields = computed(() => {
        return this.table()?.fields;
    });

    constructor() {
        super(initialState);
    }

    setTable = this.updater((state, table: DataMartTable) => ({
        ...state,
        table: table,
    }));
    getTable = this.effect((trigger$: Observable<{ tableName: string }>) => {
        return trigger$.pipe(
            exhaustMap(trigger => {
                return this.#dataMartService.getDataModel().pipe(
                    tapResponse({
                        next: dataModel => {
                            const table = dataModel.tables.find(table => table.name === trigger.tableName);
                            if (table !== undefined) {
                                this.setTable(table);
                            }
                        },
                        error: err => console.error(err),
                    })
                );
            })
        );
    });
}
